import styled from "styled-components";

export const OfferSlider = styled.div`
  --image-size: 220px;
  overflow: hidden;
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  overflow-y: auto;
.offrSlider__item{
  width: 220px;
  height: 70px;
  background: #FFFFFF;
  box-shadow: 0px 4px 18px #151550;
  border-radius: 8px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex !important;
  margin-right: 16px;
  margin-top: 4px;
}
.offrSlider__itemIcon{
  width: 50px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F3EEFF;
}
.offrSlider__itemDesc{
  padding: 14px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.offrSlider__item--text{
  font-size: 14px;
  line-height: 18px;
  color: #423862;
  font-weight: 900;
}
.offrSlider__item--text  span{
  font-weight: 700;
}

&:hover div {
  animation-play-state: paused;
}
& > div {
  display: flex;
  position: relative;
  animation: marquee 12s linear infinite;
  justify-content: space-around;
}
@media (max-width: 900px) {
  & {
    --image-size: 50px;
    --image-size: min(max(50px, 10vw), 100px);
  }
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

@media (min-width: 320px) and (max-width: 767px) {
  .offrSlider__item{
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
}
  `;

export const NewTag = styled.span`
  display: inline-flex;
  background: linear-gradient(67.62deg, #43E1A8 0%, #219393 58.33%);
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  height: 15px;
  padding: 0 6px;
  font-size: 10px;
  line-height: 10px;
  color: #fff;
  font-weight: 700;
  position: absolute;
  left: 6px;
  top: 0px;
  overflow: visible;
  z-index: 10;
  @media (max-width: 768px) {
    font-size: 8px;
  }
  &.font9 {
    font-size: 9px;
  }
`;
